import React, { Component } from "react";
import { Upload, Icon } from "antd";
import "./imgUpload.scss";
import { getInfoFromLocalStorage } from "../../../../../../../actions";
import UploadWall from "../../../../../../../components/upload/UploadWall";
import { message } from "../../../../../utils/sysManagementUtils";
import {PIC_TYPE_ORIGINAL, PIC_TYPE} from "../../../../../../../constants";
import $Jq from "jquery";
import ImgChoose from "../../../../../../editor/components/editContentChoose/ImgChoose";
import VideoCapture from "../../../../../../editor/components/editContentChoose/VideoCapture";
import {unitConvert} from "../../../../../../../utils";
import BaseComponent from "../../../../../../../base/BaseComponent";

class ImgUpload extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            imgAll: [],//内容全部图片
            videoAll: [],//内容全部视频
            newPicType:['jpg','jpeg', 'gif', 'png', 'bmp', 'JPG', 'JPEG', 'GIF', 'PNG', 'BMP'],
        };
    }
    componentWillMount() {
    }

    render() {
        const {value, disabled, defaultUpload} = this.props;
        const {imgAll, videoAll} = this.state;
        return (
            <div className="upload-wrap">
                <UploadWall
                    accept={"."+this.state.newPicType.join(",.")}
                    disabled={disabled}
                    uploadBtnName={this.props.isPcIcon}
                    name="file"
                    action="/dynamic/storage/uploadFile"
                    onChange={this.handleChange}
                    beforeUpload={this.handleBeforeUpload}
                    style={{
                        width:"130px",
                        height:"130px",
                        overflow:"hidden",
                        padding:"0"
                    }}
                    defaultUpload={defaultUpload}
                    imageUrl={value}

                />
                <div className={"upload-tip"}>
                    {
                        defaultUpload && defaultUpload === 'editColumn' ?
                            <div>
                                <div onClick={() => {
                                    this.imgChoose.showModal();
                                    this.contentChoose();
                                }} style={{
                                    alignSelf: "flex-end",
                                    color: this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3"),
                                    fontSize: "12px",
                                    cursor: "pointer",
                                    lineHeight: '12px',
                                    marginBottom: '15px'
                                }}>正文选择
                                </div>
                                <div onClick={() => {

                                    this.videoCaptureContent();
                                }} style={{
                                    alignSelf: "flex-end",
                                    color: this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3"),
                                    fontSize: "12px",
                                    cursor: "pointer",
                                    lineHeight: '12px',
                                    marginBottom: '15px'
                                }}>视频截取
                                </div>
                            </div> : null
                    }
                    {
                        disabled ? null :
                            <span onClick={()=>{this.props.onChange("")}} style={{ alignSelf: "flex-end",color:"#0050B3",fontSize:"12px",cursor:"pointer",lineHeight:'12px',marginBottom: '8px'}}>删除</span>
                    }
                    <div className="tip-text">
                        支持bmp、jpg、png等常见图片格式文件上传，图片最大限制不超过20M
                    </div>
                </div>
                {/*正文选择*/}
                <ImgChoose getImgChoose={(data)=>this.getImgChoose(data)} imgAll={imgAll} ref={e=>this.imgChoose=e}/>
                {/*视频截取*/}
                <VideoCapture getVideoPicture={(data)=>this.getVideoPicture(data)} videoAll={videoAll} ref={e=>this.videoCapture=e}/>
            </div>
        );
    }

    //上传前添加上传提示，限制非格式的上传
    handleBeforeUpload = (file, fileList) => {
        // const upload = file.type === "application/zip" ? true : false;
        let fileName = file.name.split('.');
        let upload = fileName.at(-1).toLowerCase();
        upload = this.state.newPicType.includes(upload);
        if(!upload){
            message.error('暂不支持该文件类型!');
        }
        // 限制图片大小
        let picSize=unitConvert(file.size);
        if (file && file.size) {
            if (picSize.indexOf('MB') > -1) {
                let size = picSize.slice(0, -2);
                if (size > 20) {
                    message.error('图片最大限制不超过20M！');
                    return false;
                }
                // console.log('----------****----------------------', size)
            }
            unitConvert(file.size);
        }
        return new Promise((resolve, reject) => {
            if (!upload) {
                reject(file);
            } else {
                resolve(file);
            }
        });
    };
    //正文选择
    contentChoose() {
        let currentContent = window.ueditor.getContent();
        let imgAll = $Jq(currentContent).find('img').not("[alias-label='video']").not(".edui-upload-video").not(".edui-faked-video").not(".edui-faked-music");
        if(!(imgAll && imgAll.length)) return message.error("正文中未找到图片！");
        this.setState({imgAll});
    }

    // 传标题图
    getImgChoose = (data) => {
        if(data) {
            this.props.onChange(data);
        }
    }

    isOutLink = (url) => {
        if(url) {
            let reg=/http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/;
            return reg.test(url)
        }
        return false
    }

    //视频截取
    videoCaptureContent() {
        message.destroy();
        let currentVideo = document.getElementsByName("ueditor_subcontent")[0].contentWindow.document;
        let videoList = $Jq(currentVideo).find("[alias-label='video']");
        if (!(videoList && videoList.length)) {
            return message.error("正文中未找到视频！")
        }
        let videoAll = [];
        for (let j = 0; j < videoList.length; ++j) {
            if($Jq(videoList[j]).attr("duration") >0 && !this.isOutLink($Jq(videoList[j]).attr("source-url"))){
                videoAll.push({
                    duration: $Jq(videoList[j]).attr("duration"),
                    src: $Jq(videoList[j]).attr("video-src"),// 视频内容
                    videoSrc: $Jq(videoList[j]).attr("video-pic"),//视频封面
                    videoWidth: $Jq(videoList[j]).width(),//视频封面
                    videoHeight: $Jq(videoList[j]).height(),//视频封面
                })
            }
        }
        if(!videoAll?.length){
            return  message.warn("网络视频无法视频截取！")
        }
        this.setState({videoAll},()=>{
            this.videoCapture.showModal();
        });
    }
    //传视频帧
    getVideoPicture=(data)=>{
        if (data) {
            this.props.onChange(data);
        }
    };
    handleChange = info => {
        if (info.file.status === "uploading") {
            this.setState({loading: true});
            return;
        }
        if (info.file.status === "done") {
            if (info.file.response && info.file.response.status) {
                if (info.file.response.status == 200) {
                    message.success("图片上传成功");
                    this.props.onChange(info.file.response.data.path);
                    this.setState({
                        loading: false,
                    });
                } else {
                    message.error(info.file.response.message)
                }
            }
        }
    };
}


export default ImgUpload;